import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import { Role, parseRole } from '../rbac/roles'
import { useMe } from '../api/hooks'
import type { Me } from '../api/types'

interface MeCtx {
  me: Me
  role: Role
}

const Ctx = createContext<MeCtx | null>(null)

export function MeProvider({ children, fallback }: { children: ReactNode; fallback: ReactNode }) {
  const { data, isLoading } = useMe()
  if (isLoading) return <>{fallback}</>
  if (!data) return <>{fallback}</>
  const role = parseRole(data.role) ?? Role.Viewer
  return <Ctx.Provider value={{ me: data, role }}>{children}</Ctx.Provider>
}

// eslint-disable-next-line react-refresh/only-export-components -- context hook is colocated with its provider
export function useMeCtx() {
  const c = useContext(Ctx)
  if (!c) throw new Error('no MeProvider')
  return c
}
